import { ChevronLeft, MoreHorizontal } from 'lucide-react';

interface LancDetailHeaderProps {
  title: string;
  onBack: () => void;
}

const btnStyle = {
  width: 44,
  height: 44,
  borderRadius: 'var(--r-3)',
  background: 'var(--card-soft)',
  border: '1px solid var(--card-stroke)',
  display: 'grid' as const,
  placeItems: 'center',
  color: 'var(--fg-muted)',
  cursor: 'pointer',
  flexShrink: 0,
};

/** Header da tela de detalhe: botão back + título truncado + more. */
export function LancDetailHeader({ title, onBack }: LancDetailHeaderProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, paddingTop: 4 }}>
      <button onClick={onBack} aria-label="Voltar para lista de lançamentos" style={btnStyle}>
        <ChevronLeft size={18} strokeWidth={1.8} aria-hidden />
      </button>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 10,
            letterSpacing: '0.10em',
            textTransform: 'uppercase',
            fontWeight: 600,
            color: 'var(--fg-muted)',
            marginBottom: 1,
          }}
        >
          Lançamento
        </div>
        <div
          style={{
            fontSize: 18,
            fontWeight: 700,
            letterSpacing: '-0.02em',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: 'var(--fg)',
          }}
        >
          {title}
        </div>
      </div>
      <button aria-label="Mais opções" style={btnStyle}>
        <MoreHorizontal size={17} strokeWidth={1.7} aria-hidden />
      </button>
    </div>
  );
}
